import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/project/pc/gzqx-byyj-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import Api from '@/api/localdata-service.js';
var menu = {
  namespace: true,
  state: {
    menuList: [],
    menuStatusObj: {},
    // 控制菜单活跃状态,主要为了区分样式
    menuModuleLoading: {},
    // 控制菜单加载中状态,避免用户重复点击叠加多次
    menuGroupObj: {},
    menuModuleFilterObj: {
      fc: false,
      qy: true,
      lc: false
    },
    // 需要加请求拦截的模块,由于渲染有延迟会导致图层叠加
    radarCloud: '',
    // 雷达云图配置
    moduleList: '',
    // 顶部栏模块列表
    currentModule: '',
    // 记录当前配置显示的路由
    statisTable: []
  },
  mutations: {
    SET_MENU_LIST: function SET_MENU_LIST(state, data) {
      state.menuList = data;
    },
    // 设置雷达云图配置数据，跟着菜单走
    SET_RADAR_CLOUD: function SET_RADAR_CLOUD(state, data) {
      state.radarCloud = data;
    },

    /**
     *  先分组，在提取出点击事件开关列表
     * @param {*} state
     * @param {*} data
     */
    SET_MENU_GROUP: function SET_MENU_GROUP(state) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var menuStatusObj = {}; // 父类对象

      var menuGroupObj = {};
      data.forEach(function (val, index) {
        var obj = {
          index: index,
          // 映射单个菜单位置
          name: val.name,
          // 映射单个菜单名字
          type: val.type
        }; // 子类对象

        menuStatusObj[val.type] = val.active; // 初始化菜单选中功能

        if (index === 0 || !menuGroupObj[val.group]) {
          var arr = []; // 迭代数组

          arr.push(obj);
          menuGroupObj[val.group] = arr;
        } else {
          menuGroupObj[val.group].push(obj);
        }
      });
      state.menuGroupObj = menuGroupObj; // 数据分组，区分选中事件间关系

      state.menuStatusObj = menuStatusObj; // 功能选中唤醒开关
    },
    UPDATE_MENU_LIST_STATUS: function UPDATE_MENU_LIST_STATUS(state, _ref) {
      var type = _ref.type;
      state.menuStatusObj[type] = !state.menuStatusObj[type];

      if (state.menuStatusObj[type] && state.menuModuleFilterObj[type]) {
        state.menuModuleLoading[type] = true; // 开启加载中
      }
    },
    UPDATE_MENU_LOADING: function UPDATE_MENU_LOADING(state, _ref2) {
      var type = _ref2.type,
          status = _ref2.status;
      state.menuModuleLoading[type] = status; // 修改状态
    },
    SET_MODULE_LIST: function SET_MODULE_LIST(state, data) {
      if (!data.length) return;
      state.moduleList = data;
    },
    SET_STATIS_TABLE: function SET_STATIS_TABLE(state, data) {
      if (!data.length) {
        state.statisTable = ["statis-rain-day", "statis-rain-month", "statis-rain-slot", "statis-water-reservoir", "statis-water-river"];
      } else {
        state.statisTable = data;
      }
    }
  },
  actions: {
    initFootBarMenu: function () {
      var _initFootBarMenu = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref3) {
        var commit, _this$state$projectId, projectId, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commit = _ref3.commit;
                _this$state$projectId = this.state.projectId, projectId = _this$state$projectId === void 0 ? '007' : _this$state$projectId;
                data = {};
                _context.prev = 3;
                _context.next = 6;
                return Api.GetProjectConfig(projectId);

              case 6:
                data = _context.sent;
                _context.next = 14;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](3);
                _context.next = 13;
                return Api.GetProjectConfig(projectId, "production");

              case 13:
                data = _context.sent;

              case 14:
                console.log(data);
                commit('SET_MODULE_LIST', data.module || []);
                commit('SET_STATIS_TABLE', data.statisTable || []);
                commit('SET_MENU_LIST', data.menu); // 菜单列表

                commit('SET_MENU_GROUP', data.menu); // 提交全局菜单分组

                commit('SET_RADAR_CLOUD', data.radarCloud); // 雷达云图

                window.GLOBAL_CONFIG.radarCloud = data.radarCloud; // 将雷达云图配置追加到全局对象上，20200715

                return _context.abrupt("return", data.module || []);

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 9]]);
      }));

      function initFootBarMenu(_x) {
        return _initFootBarMenu.apply(this, arguments);
      }

      return initFootBarMenu;
    }(),
    // menu change methods
    setMenuStatus: function setMenuStatus(_ref4, _ref5) {
      var commit = _ref4.commit,
          state = _ref4.state;
      var item = _ref5.item,
          index = _ref5.index,
          type = _ref5.type;
      // 优先拦截正在加载中的模块
      if (state.menuModuleLoading[item.type]) return; // error 类型用来处理发现错误时将状态切换之前状态

      if (type && type === 'error') {
        item = this.itemNow;
        index = this.indexNow;
      } else {
        this.itemNow = item; // 记录当前item

        this.indexNow = index; // 记录当前item位置
      } //


      var groups = state.menuGroupObj; // 分组列表

      var group = item.group; // 当前点击属于哪个分组，再根据group检索groups中同一个系列

      var menuStatusObj = state.menuStatusObj; // 菜单状态列表
      //

      if (group === 0) {
        commit('UPDATE_MENU_LIST_STATUS', {
          type: item.type,
          index: index
        });
      } else {
        var findGroup = groups[group]; // 系类索引

        findGroup.forEach(function (val) {
          // 这里为了找到同组互斥的另外一个，将他关掉
          if (menuStatusObj[val.type] && val.type !== item.type) {
            commit('UPDATE_MENU_LIST_STATUS', {
              type: val.type,
              index: val.index
            });
          }
        });
        commit('UPDATE_MENU_LIST_STATUS', {
          type: item.type,
          index: index
        });
      }
    }
  }
};
export default menu;